import { Component, EventEmitter, Input, OnInit, Output, forwardRef } from '@angular/core';
import { ControlContainer, FormGroupDirective, NG_VALUE_ACCESSOR } from '@angular/forms';
import { SmUiComponent } from '../sm-ui/sm-ui.component';

@Component({
  selector: 'sm-multiple-choice',
  templateUrl: './sm-multiple-choice.component.html',
  styleUrls: ['./sm-multiple-choice.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SmMultipleChoiceComponent),
      multi: true
    }
  ]
})
export class SmMultipleChoiceComponent extends SmUiComponent implements OnInit {
  @Output() checked = new EventEmitter<any>();
  @Output() multiplechecked = new EventEmitter<any>();
  @Input() options = [];
  multiSelectOptions: any[] = [];

  checkboxEmitter(event: any, option: any = []): void {
    if (this.props.propIsMultiSelect) {
      if (event.target.checked) {
        this.multiSelectOptions.push(option.id);
      } else {
        this.multiSelectOptions = this.multiSelectOptions.filter(key => key !== option.id);
      }
      // console.log(this.multiSelectOptions)
      this.multiplechecked.emit(this.multiSelectOptions);
    } else {
      this.checked.emit(event);
    }

  }
}